exports.dateTimeFormat = (date) => {
  return new Date(date).toLocaleString("en-US");
};
